import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
} from '@mui/material';

/**
 * Reusable dialog for selecting shipping type (Air or Ship).
 * Optionally shows a notice when the customer has ever had an Air parcel.
 *
 * @param {boolean} open - Whether the dialog is open
 * @param {function} onClose - Called when dialog is closed (e.g. cancel)
 * @param {function} onSelect - Called with 'Air' or 'Ship' when user selects
 * @param {boolean} [hasEverHadAirOrder] - If true, shows notice that this customer has had Air parcels before
 */
const ShippingTypeDialog = ({ open, onClose, onSelect, hasEverHadAirOrder = false }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>เลือกประเภทการส่ง</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          กรุณาเลือกประเภทการส่งสินค้า
        </Typography>
        {hasEverHadAirOrder && (
          <Alert severity="info" sx={{ mb: 2 }}>
            ลูกค้ารายนี้เคยส่งแบบแอร์ (Air) มาแล้ว
          </Alert>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '16px' }}>
          <Button
            onClick={() => onSelect('Air')}
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            style={{ paddingTop: '12px', paddingBottom: '12px', fontSize: '1.1rem' }}
          >
            ✈️ Air (แอร์)
          </Button>
          <Button
            onClick={() => onSelect('Ship')}
            variant="contained"
            color="secondary"
            size="large"
            fullWidth
            style={{ paddingTop: '12px', paddingBottom: '12px', fontSize: '1.1rem' }}
          >
            🚢 Ship (เรือ)
          </Button>
        </div>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button onClick={onClose} variant="text" color="inherit" size="small">
          ยกเลิก
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShippingTypeDialog;
